module.exports = __webpack_public_path__ + "static/media/HOMEPAGE_STORE.e7e642fe.svg";